<template>
  <div class="ucontainer">
    <div class="grid">
      <div>
        <div class="row" style="margin: 20px 0;">
          <div class="col-md-6 col-sm-12">
            <br />
            <div class="section_1">
              <div class="row ">
                <div class="col-6">
                  title
                </div>
                <div class="col">
                  <textarea
                    type="text"
                    v-model="model.landing_data.title1"
                    class="iinput"
                    :placeholder="model.landing_data.title1"
                  />
                </div>
              </div>
              <br />
              <div class="row ">
                <div class="col-6">
                  Title Next line (optional)
                </div>
                <div class="col">
                  <textarea
                    type="text"
                    v-model="model.landing_data.subTitle"
                    class="iinput"
                    :placeholder="model.landing_data.subTitle"
                  />
                </div>
              </div>
              <br />
              <div class="row ">
                <div class="col-6">
                  title Color (optional)
                </div>
                <div class="col">
                  <input
                    type="text"
                    v-model="model.landing_data.spanColor"
                    class="iinput"
                    :placeholder="model.landing_data.spanColor"
                  />
                </div>
              </div>
              <br />

              <div class="row ">
                <div class="col-6">
                  paragraph
                </div>
                <div class="col">
                  <textarea
                    type="text"
                    v-model="model.landing_data.paragraph"
                    class="iinput"
                    :placeholder="model.landing_data.paragraph"
                  />
                </div>
              </div>
              <br />
              <div class="row ">
                <div class="col-6">
                  companyLogo
                </div>
                <div class="col">
                  <input
                    type="text"
                    v-model="model.landing_data.companyLogo"
                    class="iinput"
                    :placeholder="model.landing_data.companyLogo"
                  />
                </div>
              </div>
              <br />
              <div class="row ">
                <div class="col-6">
                  Right landing Logo
                </div>
                <div class="col">
                  <input
                    type="text"
                    v-model="model.landing_data.landingImage"
                    class="iinput"
                    :placeholder="model.landing_data.landingImage"
                  />
                </div>
              </div>
            </div>

            <div class="section_2" style="padding-top:400px">
              <h2 class="manrope text-center">About the Company</h2>
              <div class="row ">
                <div class="col-6">
                  Company Name
                </div>
                <div class="col">
                  <textarea
                    type="text"
                    v-model="model.instructor_data.name"
                    class="iinput"
                    :placeholder="model.instructor_data.name"
                  />
                </div>
              </div>
              <br />

              <div class="row ">
                <div class="col-6">
                  Company Logo
                </div>
                <div class="col">
                  <textarea
                    type="text"
                    v-model="model.instructor_data.avatar"
                    class="iinput"
                    :placeholder="model.instructor_data.avatar"
                  />
                </div>
              </div>
              <br />
              <div class="row ">
                <div class="col-6">
                  info
                </div>
                <div class="col">
                  <textarea
                    type="text"
                    v-model="model.instructor_data.info"
                    class="iinput"
                    :placeholder="model.instructor_data.info"
                  />
                </div>
              </div>
              <br />

              <br />
              <div class="row ">
                <div class="col-6">
                  Background Color
                </div>
                <div class="col">
                  <input
                    type="text"
                    v-model="model.instructor_data.bgColor"
                    class="iinput"
                    :placeholder="model.instructor_data.bgColor"
                  />
                </div>
              </div>
              <div class="row ">
                <div class="col-6">
                  Text Color
                </div>
                <div class="col">
                  <input
                    type="text"
                    v-model="model.instructor_data.txtColor"
                    class="iinput"
                    :placeholder="model.instructor_data.txtColor"
                  />
                </div>
              </div>
            </div>

            <div class="section_3" style="padding-top:100px">
              <h2 class="manrope text-center">Program Structure Section</h2>
              <div class="row ">
                <div class="col-6">
                  headingInfo
                </div>
                <div class="col">
                  <textarea
                    type="text"
                    v-model="model.program_data.headingInfo"
                    class="iinput"
                    :placeholder="model.program_data.headingInfo"
                  />
                </div>
              </div>
              <br />

              <div class="row ">
                <div class="col-6">
                  seatsInfo
                </div>
                <div class="col">
                  <textarea
                    type="text"
                    v-model="model.program_data.smallHeading"
                    class="iinput"
                    :placeholder="model.program_data.smallHeading"
                  />
                </div>
              </div>
              <br />
              <div class="row ">
                <div class="col-6">
                  lenth
                </div>
                <div class="col">
                  <textarea
                    type="text"
                    v-model="model.program_data.lenth"
                    class="iinput"
                    :placeholder="model.program_data.lenth"
                  />
                </div>
              </div>
              <br />
              <div class="row ">
                <div class="col-6">
                  startDate
                </div>
                <div class="col">
                  <input
                    type="text"
                    v-model="model.program_data.startDate"
                    class="iinput"
                    :placeholder="model.program_data.startDate"
                  />
                </div>
              </div>
              <br />
              <div class="row ">
                <div class="col-6">
                  cost Info
                </div>
                <div class="col">
                  <textarea
                    type="text"
                    v-model="model.program_data.cost"
                    class="iinput"
                    :placeholder="model.program_data.cost"
                  />
                </div>
              </div>
              <br />

              <div class="row ">
                <div class="col-6">
                  deadline
                </div>
                <div class="col">
                  <textarea
                    type="text"
                    v-model="model.program_data.deadline"
                    class="iinput"
                    :placeholder="model.program_data.deadline"
                  />
                </div>
              </div>
              <br />

              <br />
              <div class="row ">
                <div class="col-6">
                  jobOppurtunity
                </div>
                <div class="col">
                  <textarea
                    type="text"
                    v-model="model.program_data.jobOppurtunity"
                    class="iinput"
                    :placeholder="model.program_data.jobOppurtunity"
                  />
                </div>
              </div>

              <br />

              <br />
              <div class="row ">
                <div class="col-6">
                  Background Color
                </div>
                <div class="col">
                  <textarea
                    type="text"
                    v-model="model.program_data.bgColor"
                    class="iinput"
                    :placeholder="model.program_data.bgColor"
                  />
                </div>
              </div>
              <div class="row ">
                <div class="col-6">
                  TextColor
                </div>
                <div class="col">
                  <input
                    type="text"
                    v-model="model.program_data.txtColor"
                    class="iinput"
                    :placeholder="model.program_data.txtColor"
                  />
                </div>
              </div>
            </div>
            <!-- <div class="section_4_position_info" style="padding-top:500px">
              <h2 class="manrope text-center">Position Info</h2>
              <br />
              <div class="row ">
                <div class="col-6">
                  paragraph
                </div>
                <div class="col">
                  <textarea
                    type="text"
                    v-model="model.other.paragraph"
                    class="iinput"
                    :placeholder="model.other.paragraph"
                  />
                </div>
              </div>
              <br />
              <div class="row ">
                <div class="col-6">
                  remote frienly?
                </div>
                <div class="col">
                  <input
                    type="text"
                    v-model="model.other.remote"
                    class="iinput"
                    :placeholder="model.other.remote"
                  />
                </div>
              </div>
              <br />
              <div class="row ">
                <div class="col-6">
                  Job type?
                </div>
                <div class="col">
                  <input
                    type="text"
                    v-model="model.otherjobType"
                    class="iinput"
                    :placeholder="model.other.positionInfojobType"
                  />
                </div>
              </div>
              <br />
              <div class="row ">
                <div class="col-6">
                  Text color
                </div>
                <div class="col">
                  <input
                    type="text"
                    v-model="model.other.positionInfotxtColor"
                    class="iinput"
                    :placeholder="model.other.positionInfotxtColor"
                  />
                </div>
              </div>
            </div> -->

            <div
              class="section_5_company_testimonial"
              style="padding-top:100px"
            >
              <h2 class="manrope text-center">Company Testimonial</h2>
              <br />
              <div class="row ">
                <div class="col-6">
                  paragraph
                </div>
                <div class="col">
                  <textarea
                    type="text"
                    v-model="model.company_testimonial.paragraph"
                    class="iinput"
                    :placeholder="model.company_testimonial.paragraph"
                  />
                </div>
              </div>
              <br />
              <div class="row ">
                <div class="col-6">
                  name?
                </div>
                <div class="col">
                  <input
                    type="text"
                    v-model="model.company_testimonial.name"
                    class="iinput"
                    :placeholder="model.company_testimonial.name"
                  />
                </div>
              </div>
              <br />
              <div class="row ">
                <div class="col-6">
                  designation
                </div>
                <div class="col">
                  <input
                    type="text"
                    v-model="model.company_testimonial.designation"
                    class="iinput"
                    :placeholder="model.company_testimonial.designation"
                  />
                </div>
              </div>
              <br />
              <div class="row ">
                <div class="col-6">
                  Image
                </div>
                <div class="col">
                  <input
                    type="text"
                    v-model="model.company_testimonial.mainImg"
                    class="iinput"
                    :placeholder="model.company_testimonial.mainImg"
                  />
                </div>
              </div>

              <br />
              <div class="row ">
                <div class="col-6">
                  Image background Color
                </div>
                <div class="col">
                  <input
                    type="text"
                    v-model="model.company_testimonial.imgBg"
                    class="iinput"
                    :placeholder="model.company_testimonial.imgBg"
                  />
                </div>
              </div>
            </div>

            <div
              class="section_5_company_testimonial"
              style="padding-top:100px"
            >
              <h2 class="manrope text-center">Faq</h2>
              <div class="row ">
                <div class="col-6">
                  time for Assessment
                </div>
                <div class="col">
                  <input
                    type="text"
                    v-model="assessmentDuration"
                    class="iinput"
                    :placeholder="assessmentDuration"
                  />
                </div>
              </div>

              <div class="row ">
                <div class="col-6">
                  previous work experience
                </div>
                <div class="col">
                  <textarea
                    type="text"
                    v-model="previousWorkExperience"
                    class="iinput"
                    :placeholder="previousWorkExperience"
                  />
                </div>
              </div>

              <br />

              <div class="row ">
                <div class="col-6">
                  salary
                </div>
                <div class="col">
                  <input
                    type="text"
                    v-model="salary"
                    class="iinput"
                    :placeholder="salary"
                  />
                </div>
              </div>

              <div class="row ">
                <div class="col-6">
                  company Name
                </div>
                <div class="col">
                  <input
                    type="text"
                    v-model="companyName"
                    class="iinput"
                    :placeholder="companyName"
                  />
                </div>
              </div>
            </div>
            <button class="btn " @click="publish()">
              submit
            </button>
          </div>
        </div>
      </div>
      <div>
        <Landing :landingData="model.landing_data" />
        <AboutCompany id="about" :instructorData="model.instructor_data" />
        <ProgramInfo id="program" :info="model.program_data" />
        <BasicRequirement />
        <PositionSummary :info="positionInfo" />
        <TestimonialCompany :info="model.company_testimonial" />
        <Faq id="faq" :info="faq" />
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import TestimonialCompany from '../components/isaMain/CompanyTestimonial.vue'
import Landing from '../components/AssessmentIsa/LandingAssessment.vue'
import AboutCompany from '../components/AssessmentIsa/AboutTheCompany.vue'
import ProgramInfo from '../components/AssessmentIsa/ProgramInfo.vue'
import BasicRequirement from '../components/isaMain/BasicRequirement.vue'
import PositionSummary from '../components/AssessmentIsa/PositionSummary.vue'

import Faq from '../components/isaMain/Faq.vue'
export default {
  data() {
    return {
      model: {
        category: 'Assessment',
        active: false,

        landing_data: {
          title1: 'Your first step towards a Financial Analyst Position',
          subtitle: '',
          spanColor: '#29292b',
          paragraph:
            'Upskill presents a thorough bootcamp only designed for junior to mid level Financial analysts/managers.Take part in this bootcamp, and get a chance to work at CMED, an IoT enabled AI driven cloud based smart medical platform for primary and preventive healthcare. Salary range will be 50k-100k based on work experience.You will be taught by Fayaz Taher',
          companyLogo: require('../assets/cmed/cmed-logo.png'),
          quizLink:
            'https://quiz.upskill.com.bd/assessment/37a6c7d6-f21c-48e1-968e-74336c5109c3?public=true&job=isa_financial_analyst',
          landingImage: require('../assets/cmed/cmed-instuctor.png'),
        },
        instructor_data: {
          name: 'Fayaz Taher',
          avatar: require('../assets/cmed/fayaz_bhai_avatar.png'),
          info:
            'Fayaz is a serial entrepreneur, investor, mentor and a startup community advocate from Bangladesh. Fayaz co-founded Startup Dhaka and Magnito digital. He also is a director at Fortuna Group that has investments in various sectors including life insurance, insurance, food and leather. Currently he is working as COO of the largest streaming services in Bangladesh.',
          designation: '',

          additionalInfo:
            'Fayaz is currently in the role of Chief of Operating Officer at Bongo which is the largest Video platform and Multichannel network in Bangladesh.Fayaz was the CEO of Fortuna and managing all aspects of the business including marketing, production, development, financial forecasting, material sourcing, and digitizing way of work in the company. Managing multiple teams cross border with offices in China and Bangladesh.Director of IBT, which was announced as one of the winners of the FbFund in 2008 in social gaming. Helped reached over 1 million users and daily monetization. IBT was also a tech partner in socialbuy.com which was sold to kbgdeals.Co-Founder at Startup Dhaka which is a platform for startups and investors in Bangladesh which operated the Grameenphone Accelerator, launched a new pitching show called Tiger Cage, and an education platform called Upskill in Bangladesh. Working as a in-house mentor as well as mentor to tech other startups.He has undergraduate degree from Babson College in USA and Masters Degree from Clark University in USA.Specialties: Financial budgeting & Costing, Strategic Planning, Investment Decisions,Operations, Sourcing, Marketing, Advertising, Conceptual Design',
          bgColor: '#EA4424',
        },
        program_data: {
          headingInfo:
            'Assessment Test for the role of Software Developer at Canadian Tech company consists of approximately 10 MCQs. You are required to pass an assessment test with a minimum 60% of the total score.',
          smallHeading:
            'Top 5-10 Candidates will get the chance to go to the interview round directly after completing the assessment.. So, don’t miss this opportunity as the time is limited! ',
          lenth: '5 weeks',
          startDate: '15th Jan,2022',
          cost: 'BDT 8000**',
          deadline: '10th Jan,2022',

          jobOppurtunity:
            'If you are one of the top 5 students by the end of 6 weeks, you will get to interview at CMED for the Financial Analyst position. So, don’t miss the offer as the seats are limited!',
          quizLink:
            'https://quiz.upskill.com.bd/assessment/37a6c7d6-f21c-48e1-968e-74336c5109c3?public=true&job=isa_financial_analyst',
          bgColor: '#1EBCE5',
          txtColor: '#EA4424',
        },

        company_testimonial: {
          mainImg: require('../assets/cmed/WhatsApp Image 2021-12-19 at 5.01.59 PM.png'),
          name: 'Dr. Khondaker A. Mamun',
          paragraph:
            'As an award winning health care startup, we are looking for a passionate financial analyst who can help us navigate financial reporting, investor updates, financial modelling etc. so we are compliant and always up to date',
          designation: 'Founder & Chairman',
          invertedCommaBg: '',
        },
        basic_requirements: {
          mainContent: [],
          bgColor: '',
        },
        // positionInfo: {
        //   paragraph:
        //     'Seeking a creative Sr. Software Developer with 5+ years of software development experience with web technologies including HTML5, CSS3 and JavaScript and Golang. You will apply software design principles and patterns to develop a suite of sales applications. Your extensive project experience and leadership will mentor junior developers. If you’re seeking a challenging role and striving to elevate your career, join the Telmax team!',
        //   remote: 'This is a remote position.',
        //   jobType: 'Job Type: Full-time (Remote)',
        //   txtColor: '#5277F7',
        // },

        faq: [
          {
            title: 'What is the duration of the assessment? \n',
            content: this.assessmentDuration,
            category: 'FAQ',
          },
          {
            title: 'What is the assessment  fee? \n',
            content: 'It is free',
            category: 'FAQ',
          },
          {
            title: 'Do you need previous work experience? \n',
            content: this.previousWorkExperience,
            category: 'FAQ',
          },
          {
            title: 'How much do I need to secure to qualify?\n',
            content: '60% of the total score i.e. 6 out of 10',
            category: 'FAQ',
          },

          {
            title: 'How many times can I take the quiz?\n',
            content:
              'You can take the quiz twice. The highest score will be counted as the final score.\n',
            category: 'FAQ',
          },
          {
            title:
              'Will all the top 5 students get a job at ' +
              this.companyName +
              '?',
            content:
              'No, the top 5 students will get a chance to interview at' +
              this.companyName +
              ', and will get the job depending on their performance in the interview.\n',
            category: 'FAQ',
          },
          {
            title: 'Salary?\n',
            content: this.salary,
            category: 'FAQ',
          },
        ],
      },
    }
  },
  components: {
    PositionSummary,
    Landing,
    AboutCompany,
    ProgramInfo,
    TestimonialCompany,
    BasicRequirement,
    Faq,
  },

  created() {
    this.Loaded()
  },
  methods: {
    publish() {
      axios.post(
        'https://isaservice.upskill.com.bd/user/landing',
        this.model,
        {}
      )
    },
  },
}
</script>

<style scoped>
.grid {
  display: grid;
  grid-template-columns: 1fr 2fr;
}
</style>
